import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FullPageLoader} from './full-page-loader';
import {FullPageLoaderComponent} from './full-page-loader.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
    providers: [FullPageLoader],
    exports: [FullPageLoaderComponent],
    declarations: [FullPageLoaderComponent],
    imports: [MatProgressSpinnerModule, CommonModule]
})
export class FullPageLoaderModule {
}